import { Url } from '../../../../shared/constant/url.constant';

/**
 * Route utilisées pour les fees & benefits.
 */
export namespace ConstantChampsFormulaires {
  export const data = {
    title: 'Champs Formulaires',
    sub: {
      lister: 'Lister',
      ajouter: 'Ajouter',
      ajout: {
        title: 'Ajout d\'un Champs Formulaire'
      },
      liste: 'Liste',
      list: {
        title: 'Liste des Champs Formulaire'
      }
    }

  }
  export const url = {
    FEES: {
      FEES_: 'champs_formulaire',
      LIST: 'liste',
      ADD: 'add'
    }
  };

  export const urlFull = {
    FEES: {
      ADD: ConstantChampsFormulaires.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantChampsFormulaires.url.FEES.ADD),
      LIST: ConstantChampsFormulaires.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantChampsFormulaires.url.FEES.LIST),
    }
  };
}
